// src/401.js
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import logo from "../pages/assets/logo.png";
import police from "../pages/assets/police.svg";
import four01 from "../pages/assets/401.svg";
import callIcon from "../pages/assets/call.svg";
import "./401.css";

export default function UnauthorizedErrorPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useUser();
  const attemptedPath = location.state?.from || "this page";

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/", { replace: true });
    } catch (error) {
      console.error("Logout error:", error);
      // Even if logout fails, clear local storage and redirect
      localStorage.clear();
      navigate("/", { replace: true });
    }
  };

  return (
    <div className="error1">
    <div className="page-container">
      <header className="header">
        <img src={logo} alt="Login" className="logo" />
        <a href="tel:+1234567890" className="call-btn">
          <img src={callIcon} alt="Call" className="call-icon" />
          Click to Call
        </a>
      </header>
      <main className="content">
        <div className="content-left">
          <img src={four01} alt="401 Unauthorized" className="four01" />
          <h2>ACCESS DENIED</h2>
          <p>You are not authorized to view {attemptedPath}.</p>
          <div className="button-container">
            <a href="/" className="home-btn">Back to Home</a>
            <button onClick={handleLogout} className="logout-btn">Log Out</button>
          </div>
        </div>
        <div className="content-right">
          <img src={police} alt="Police Illustration" className="illustration" />
        </div>
        <img src={police} alt="Police Illustration" className="mobile-police" />
      </main>
    </div>
    </div>

  );
}